<template>
  <div id="app">
    <BonusCalc />
  </div>
</template>

<script>
import BonusCalc from "@/views/BonusCalc.vue";
export default {
  name: "App",
  components: {
    BonusCalc,
  },
  created() {
    const pathName = window.location.pathname;
    const lang = pathName.includes("/en/") ? "en" : pathName.includes("/jp/") ? "jp" : "ru";

    this.$i18n.locale = lang;
  },
};
</script>

<style lang="scss">
@import "@/assets/scss/index.scss";

* {
  margin: 0;
  padding: 0;
}

#app {
  font-family: "muller";
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  color: #2c3e50;
}
</style>
